import { Link } from 'react-router-dom';
import type { Match, TeamInfo } from '@/lib/site';

interface LineupPanelProps {
  match: Match;
  team: TeamInfo;
  side: 'home' | 'away';
}

const teamAccent = {
  home: {
    badge: 'bg-primary-50 text-primary-700',
    bar: 'bg-primary-600',
    tag: 'bg-primary-50 text-primary-700',
  },
  away: {
    badge: 'bg-accent-50 text-accent-700',
    bar: 'bg-accent-500',
    tag: 'bg-accent-50 text-accent-700',
  },
};

export default function LineupPanel({ match, team, side }: LineupPanelProps) {
  const accent = teamAccent[side];

  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <span className={`w-10 h-10 rounded-md font-heading text-xs flex items-center justify-center shrink-0 ${accent.badge}`}>
            {team.shortName}
          </span>
          <div className="min-w-0">
            <h3 className="text-sm font-medium text-foreground-950 truncate">{team.name}</h3>
            <p className="text-[11px] text-foreground-500 mt-0.5">
              {side === 'home' ? '主队' : '客队'} · {team.record}
            </p>
          </div>
        </div>
        <span className={`rounded-full px-2 py-0.5 text-[11px] whitespace-nowrap ${accent.tag}`}>
          {side === 'home' ? 'HOME' : 'AWAY'}
        </span>
      </div>

      <div className="mt-3.5">
        <p className="text-[11px] text-foreground-500 mb-1.5">预计首发</p>
        <ul className="space-y-1.5">
          {team.starters.map((player) => (
            <li key={player} className="flex items-center gap-2 text-sm text-foreground-800">
              <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${accent.bar}`} />
              {player}
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between text-[11px] text-foreground-500">
        <span>主教练：{team.coach}</span>
        <span>{match.venue}</span>
      </div>

      <Link
        to={`/search?q=${encodeURIComponent(team.name)}`}
        className="mt-3 inline-flex items-center gap-1 text-[11px] text-primary-700 hover:text-primary-900 transition-colors"
      >
        <i className="ri-search-line" />
        搜索 {team.name} 相关赛事
      </Link>
    </div>
  );
}